import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, theme } from '@marriott/mi-ui-library-shop';
import { baseVariables } from '@marriott/mi-ui-library';

export const StyledPointsFilterDiv = styled.div`
  ${rtl`
  .show-more-less-option {
    display: flex;
    align-items: flex-start;
    margin-top: ${toRem(10)};
    .icon-arrow-up,
    .icon-arrow-down {
      margin-left: ${toRem(6)};
    }
    &:hover {
      cursor: pointer;
    }
  }

  @media only ${theme.mediaQuery.allMobiles} {
    padding-top: 0;
    padding-bottom: 0;
    .show-more-less-option {
      margin-bottom: ${toRem(16)};
    }
  }
  `}
`;

export const StyledPointsContainerDiv = styled.div`
  ${rtl`
  padding-top: ${toRem(24)};
  .points-value {
    margin-top: ${toRem(-7)};
  }

  .filter-heading {
    letter-spacing: ${toRem(1.3)};
    text-transform: capitalize;
  }

  .filter-sub-heading{
    color: ${theme.color['dove-grey']};
    letter-spacing: ${toRem(1.3)};
    text-transform: capitalize;
  }

  .show-more-less-option {
    display: flex;
    align-items: flex-start;
    margin-top: ${toRem(10)};
    .icon-arrow-up,
    .icon-arrow-down {
      margin-left: ${toRem(6)};
    }
    &:hover {
      cursor: pointer;
    }
  }

  @media only ${theme.mediaQuery.allMobiles} {
    padding-top: 0;
    padding-bottom: 0;
    .show-more-less-option {
      margin-bottom: ${toRem(16)};
    }
  }`}
`;

export const StyledHeaderContainerDiv = styled.div`
  ${rtl`
  @media only ${theme.mediaQuery.allMobiles} {
    margin-top: ${toRem(16)};
  }`}
`;

export const StyledPointsItemsContainerDiv = styled.div`
  ${rtl`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  `}
`;

export const StyledPointsItemDiv = styled.div`
  ${rtl`
  width: 50%;
  padding: ${toRem(8)} 0;
  &.disabled {
    opacity: .7;
    pointer-events:none;
  }
  .radio-container {
    margin-bottom: 0;
    margin-left: 0;
    border-bottom: none;
    padding: 0;

    .item-name {
      padding-left: ${toRem(25)};
      margin-bottom: auto;
      width: fit-content;
      &:focus {
        outline: ${toRem(1)} solid ${theme.color['black']};
        outline-offset: ${toRem(2)};
      }
    }
    input[type='radio'] + label {
      &.checkbox-radio {
        margin-bottom: 0;
        border: 0;
        padding-top: 0;
        padding-bottom: 0;
        padding-left: ${toRem(26)};
        line-height: ${toRem(20)};
        font-size: ${toRem(14)};
        &:before {
          top: ${toRem(0)};
          left: 0;
          width: ${toRem(20)};
          height: ${toRem(20)};
        }
        &:after {
          left: ${toRem(7)};
          top: ${toRem(7)};
          width: ${toRem(6)};
          height: ${toRem(6)};
        }
        .item-name {
          padding-left: ${toRem(8)};
        }
      }
    }
  }
  @media only ${theme.mediaQuery.allTablets} {
    .radio-container {
      outline: none;
      &::before {
        outline: none;
      }
      .radio-input {
        outline: none;
        &::before {
        outline: none;
      }
      }
      .item-name {
        outline: none;
        &:focus {
          outline: none;
        }
        &::before {
          outline: none;
        }
      }
      input[type='radio'] + label {
        &.checkbox-radio {
          outline: 0;
          &::before {
            outline: none;
          }
        }
      }
    }
  }
  @media only ${theme.mediaQuery.allMobiles} {
    .radio-container {
      outline: none;
      &::before {
        outline: none;
      }
      .radio-input {
        outline: none;
        &::before {
        outline: none;
      }
      }
      .item-name {
        outline: none;
        &:focus {
          outline: none;
        }
        &::before {
          outline: none;
        }
      }
      input[type='radio'] + label {
        &.checkbox-radio {
          outline: 0;
          &::before {
            outline: none;
          }
        }
      }
    }
  }
  `}
`;

export const StyledPointsIncludeTaxesDiv = styled.div`
  ${rtl`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: ${toRem(18)};
  margin-bottom: ${toRem(24)};
  .include-taxes-and-fees-price-label {
    text-transform: none;
    letter-spacing: 0;
  }
  .checkbox-switch-wrapper {
    display: flex;
    align-items: center;

    &:active {
      outline: none !important;
    }

    .checkbox-slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: ${theme.color['light-gray-6']};
      transition: 0.4s;
      border-radius: ${toRem(34)};
      border: ${toRem(1)} solid ${theme.color['light-gray-3']};
      &:before {
        position: absolute;
        content: '';
        height: ${toRem(28)};
        width: ${toRem(28)};
        left: ${toRem(0.5)};
        top: ${toRem(1)};
        background-color: ${theme.color['white']};
        transition: 0.4s;
        border-radius: ${toRem(34)};
        border: none;
      }
    }
    .checkbox-switch {
      display: inline-block;
      width: ${toRem(52)};
      height: ${toRem(32)};
      position: relative;
      margin-right: 0;

      &::before {
        border-color: transparent;
      }
    }

    .checkbox-switch + input {
      opacity: 0;
    }

    input[type='checkbox']:checked + .checkbox-slider {
      background-color: ${theme.color['black']};
      border-color: ${theme.color['light-gray-3']};
    }

    input[type='checkbox']:checked + .checkbox-slider:before {
      background-color: ${theme.color['light-gray-3']};
      transform: translateX(${toRem(19)});
      border-radius: 50%;
      left: ${toRem(2)};
    }
    &:focus,
    &:active {
      outline: ${toRem(1)} solid ${theme.color['black']};
      outline-offset: ${toRem(2)};
    }
  }
  `}
`;

export const StyledPointsModalDiv = styled.div`
  ${rtl`
  .pop-up-footer {
    padding: ${toRem(12)} ${toRem(16)};
    @media ${baseVariables.mediaQuery.md} {
      padding: ${toRem(20)} ${toRem(32)};
    }
  }
    .filter-option-button {
      font-weight: ${theme.fonts['fontWeightRegular']};
    }
    .filter-option-button:focus {
      outline: 0px solid -webkit-focus-ring-color;
    }
  `}
`;
